import FontFaceObserver from 'fontfaceobserver';

export default () => {
	const $html = document.getElementsByTagName('html')[0];
	const titling = new FontFaceObserver('titling-gothic-fb');
	const heading = new FontFaceObserver('Titillium Web');
	const body = new FontFaceObserver('neue-haas-unica');

	Promise.all([titling.load(), heading.load(), body.load()])
		.then(() => $html.classList.add('fonts-loaded'))
		.catch(() => $html.classList.add('fonts-failed'));
};
